export enum FindProjectsSortBy {
   ADDRESS_1 = "address_1",
   ADDRESS_2 = "address_2",
   BID_RATE = "bid_rate",
   CITY_TOWN = "city_town",
   COUNTRY = "country",
   CREATED_AT = "created_at",
   CUSTOM_FIELD = "custom_field",
   CUSTOMER_NAME = "customer_name",
   DAILY_END_TIME = "daily_end_time",
   DAILY_START_TIME = "daily_start_time",
   EST_END_DATE = "est_end_date",
   HAS_PROCORE_MAPPING = "has_procore_mapping",
   ID = "id",
   NAME = "name",
   NUMBER = "job_number",
   PERCENT_COMPLETE = "percent_complete",
   START_DATE = "start_date",
   STATE_PROVINCE = "state_province",
   STATUS = "status",
   TAG_INSTANCES = "tag_instances",
   PROJECT_ROLES = "project_roles",
   TIMEZONE = "timezone",
   TYPE = "type",
   WAGE_OVERRIDES = "wage_overrides",
   ZIP_CODE = "zip_code",
   CORNERSTONE_STAGE = "cornerstone_stage_name",
}

export enum FieldMapping {
   PROJECT_HASH = "job_number",
   CITY = "city_town",
   STATE = "state_province",
   POSTAL = "zipcode",
   GROUPS = "group_ids",
   STATUS = "status",
   START_DATE = "start_date",
   EST_END_DATE = "est_end_date",
   DAILY_START_TIME = "daily_start_time",
   DAILY_END_TIME = "daily_end_time",
   TIMEZONE = "timezone",
   BID_RATE = "bid_rate",
   PERCENT_COMPLETE = "percent_complete",
   COLOR = "color",
   CORNERSTONE_STAGE_NAME = "cornerstone_stage_name",
}
